import { Txt } from '@stenajs-webui/core';
import type { DetailedIntermodalBooking } from '../../../common/graphql/fragments/gql/IntermodalBooking';
import { useLocalDateFormat } from '../../../common/hooks/useLocalDateFormat';
import { formatSailingLinkText } from '../../../common-ui/sailing-info/utils/formatSailingLinkText';

export const IntermodalJourneyTxt = ({ booking }: { booking: DetailedIntermodalBooking }) => {
  const dateFormat = useLocalDateFormat();

  return <Txt>{formatSailingLinkText(booking.journey, booking.journey.route.id, dateFormat)}</Txt>;
};
